import { apiClient } from "../_lib/apiClient";

const getTransactions = async ({ bookingId }) => {
  const response = await apiClient.get(`/transaction/booking/${bookingId}`);
  return response;
};

const getTransactionDetails = async ({ transactionId }) => {
  const response = await apiClient.get(`/transaction/${transactionId}/detail`);
  return response;
};

const getPayouts = async ({ bookingId }) => {
  const response = await apiClient.get(`/transaction/payout/${bookingId}`);
  return response;
};

const getPayoutDetails = async ({ payoutId }) => {
  const response = await apiClient.get(`/transaction/payout/${payoutId}/detail`);
  return response;
};

const getWalletDetail = async (page) => {
  const response = await apiClient.get(`/wallet?page=${page}&pageSize=10`);
  return response;
};

const getCustomDashboardDetails = async (page, search) => {
  const response = await apiClient.get(
    `/custom/hostCustomDashboardDetails?page=${page}&search=${search}`
  );
  return response;
};

const requestPayout = async (operationKey) => {
  const response = await apiClient.post(`/transferVirtualAmountToHostAccount`, {}, {
    headers: {
      "Idempotency-Key": operationKey,
    },
  });
  return response;
};

const getPayoutOperation = async (operationId) => {
  return apiClient.get(`/payout-operations/${operationId}`);
};

const getActivePayoutOperation = async () => {
  return apiClient.get(`/payout-operations/active`);
};

const createPayoutOperationKey = () => {
  if (globalThis.crypto && typeof globalThis.crypto.randomUUID === "function") {
    return globalThis.crypto.randomUUID();
  }
  const bytes = new Uint8Array(16);
  globalThis.crypto.getRandomValues(bytes);
  return `payout:${Array.from(bytes, (value) =>
    value.toString(16).padStart(2, "0")
  ).join("")}`;
};

const updateStripeAccount = async (data, representative, owners) => {
  const response = await apiClient.post(
    `/update_account_connect`,
    {
      data: data,
      representative,
      owners,
    }
  );
  return response;
};

const getStripeConnectDraftData = async (type) => {
  const response = await apiClient.get(
    `/transaction/custom/stripe_connect_draft?type=${type}`
  );
  return response;
};

const saveStripeConnectDraftData = async (type, formdata) => {
  const response = await apiClient.post(
    `/transaction/custom/save_stripe_connect_draft`,
    {
      type,
      formdata,
    }
  );
  return response;
};

const getGraphData = async (data) => {
  return await apiClient.post("/custom/host-graph-data", data);
};

export const payoutService = {
  updateStripeAccount,
  getTransactions,
  getTransactionDetails,
  getPayouts,
  getPayoutDetails,
  getWalletDetail,
  requestPayout,
  getPayoutOperation,
  getActivePayoutOperation,
  createPayoutOperationKey,
  getStripeConnectDraftData,
  saveStripeConnectDraftData,
  getCustomDashboardDetails,
  getGraphData,
};
